module.exports = __webpack_public_path__ + "img/more.177eec9c.png";